import { Container } from "reactstrap";
import cn from "classnames";
import styles from "./styles.module.scss";

export const FeaturesGrid = ({ className, items }) => {
  return (
    <section className={cn(styles.FeaturesGrid, className)}>
      <Container>
        <div className={styles.grid}>
          {items?.map((item, i) => (
            <div className={styles.col} key={i}>
              {item.icon?.url && <img src={item.icon.url} alt={item.icon.alt || "icon"} className={styles.icon} />}
              {item.title && <h3 data-sourceflow-prop={`items.${i}.title`}>{item.title}</h3>}
              {item.description && (
                <div
                  data-sourceflow-prop={`items.${i}.description`}
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
              )}
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default FeaturesGrid;
